import "core-js/modules/es.array.fill.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  width: "28",
  height: "24",
  viewBox: "0 0 28 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_2 = {
  "clip-path": "url(#clip0_413_2412)"
};
var _hoisted_3 = ["fill"];
var _hoisted_4 = ["fill"];

var _hoisted_5 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_413_2412"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "26.5",
  height: "23.3",
  fill: "white",
  transform: "translate(0.666504 0.0166626)"
})])], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, [_createElementVNode("g", _hoisted_2, [_createElementVNode("path", {
    d: "M26.5665 13.9167H24.0665C23.7665 13.9167 23.4665 14.2167 23.4665 14.5167V19.0167H4.3665V14.5167C4.3665 14.2167 4.1665 13.9167 3.7665 13.9167H1.2665C0.966504 13.9167 0.666504 14.2167 0.666504 14.5167V22.7167C0.666504 23.0167 0.866504 23.3167 1.2665 23.3167H26.6665C26.9665 23.3167 27.2665 23.1167 27.2665 22.7167V14.5167C27.1665 14.2167 26.8665 13.9167 26.5665 13.9167ZM3.7665 20.2167H24.0665C24.3665 20.2167 24.6665 20.0167 24.6665 19.6167V15.1167H26.0665V22.2167H1.7665V15.1167H3.1665V19.6167C3.1665 19.9167 3.4665 20.2167 3.7665 20.2167Z",
    fill: $props.fill
  }, null, 8, _hoisted_3), _createElementVNode("path", {
    d: "M21.1663 9.81666L19.4663 7.91666C19.3663 7.81666 19.2663 7.71666 19.0663 7.71666C18.9663 7.71666 18.7663 7.71666 18.6663 7.81666L15.6663 10.4167V0.616663C15.6663 0.316663 15.3663 0.0166626 15.0663 0.0166626H12.6663C12.3663 0.0166626 12.0663 0.216663 12.0663 0.616663V10.5167L9.06632 7.91666C8.96632 7.81666 8.86632 7.71666 8.66632 7.71666C8.46632 7.71666 8.36632 7.81666 8.26632 7.91666L6.86632 9.51666L6.66632 9.81666C6.56632 9.91666 6.46632 10.1167 6.56632 10.2167C6.56632 10.4167 6.66632 10.5167 6.76632 10.6167L13.6663 16.7167C13.7663 16.8167 13.8663 16.8167 13.9663 16.8167C14.0663 16.8167 14.1663 16.8167 14.2663 16.7167L21.1663 10.6167C21.2663 10.5167 21.3663 10.4167 21.3663 10.2167C21.3663 10.1167 21.2663 9.91666 21.1663 9.81666ZM13.8663 15.4167L7.76632 10.1167L8.66632 9.11666L12.1663 12.2167C12.3663 12.3167 12.5663 12.4167 12.7663 12.3167C12.9663 12.2167 13.0663 12.0167 13.0663 11.8167V1.11666H14.6663V11.7167C14.6663 11.9167 14.7663 12.1167 14.9663 12.2167C15.1663 12.3167 15.3663 12.3167 15.5663 12.1167L19.0663 9.01666L19.9663 10.0167L13.8663 15.4167Z",
    fill: $props.fill
  }, null, 8, _hoisted_4)]), _hoisted_5]);
}